import { useState, useEffect } from 'react';

import i18n, { LanguageType } from '../../i18n.config';

export const useCurrentLanguage = () => {
  const [currentLanguage, setCurrentLanguage] = useState<LanguageType>(
    i18n.language as LanguageType
  );

  useEffect(() => {
    const handleLanguageChange = (lang: LanguageType) => {
      setCurrentLanguage(lang);
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  return currentLanguage;
};